interface VideoProps {
  videoUrl?: string;
  title?: string;
  caption?: string;
  aspectRatio?: '16:9' | '4:3' | '1:1';
  autoplay?: boolean;
  controls?: boolean;
}

const ASPECT_PADDING: Record<string, string> = {
  '16:9': 'pb-[56.25%]',
  '4:3': 'pb-[75%]',
  '1:1': 'pb-[100%]',
};

function getEmbedUrl(url: string, autoplay: boolean, controls: boolean): string | null {
  try {
    const u = new URL(url);
    const ytMatch =
      u.hostname.includes('youtube.com') || u.hostname.includes('youtu.be')
        ? u.hostname.includes('youtu.be')
          ? u.pathname.slice(1)
          : u.searchParams.get('v')
        : null;
    if (ytMatch) {
      const params = new URLSearchParams({ autoplay: autoplay ? '1' : '0', controls: controls ? '1' : '0', rel: '0' });
      return `https://www.youtube.com/embed/${ytMatch}?${params}`;
    }
    const vimeoMatch = u.hostname.includes('vimeo.com') ? u.pathname.split('/').filter(Boolean)[0] : null;
    if (vimeoMatch) {
      const params = new URLSearchParams({ autoplay: autoplay ? '1' : '0', controls: controls ? '1' : '0' });
      return `https://player.vimeo.com/video/${vimeoMatch}?${params}`;
    }
    return null;
  } catch {
    return null;
  }
}

export function VideoBlock({ props }: { props: VideoProps }) {
  if (!props.videoUrl) return null;
  const embedUrl = getEmbedUrl(props.videoUrl, props.autoplay ?? false, props.controls !== false);
  const paddingClass = ASPECT_PADDING[props.aspectRatio ?? '16:9'] ?? ASPECT_PADDING['16:9'];

  return (
    <div className="py-4 px-4">
      {props.title && <h3 className="text-lg font-semibold text-zinc-800 mb-3">{props.title}</h3>}
      <div className={`relative w-full ${paddingClass} rounded-xl overflow-hidden bg-black`}>
        {embedUrl ? (
          <iframe
            src={embedUrl}
            className="absolute inset-0 w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title={props.title ?? 'Video'}
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-white/60 text-sm">
            URL video non supportato
          </div>
        )}
      </div>
      {props.caption && <p className="mt-2 text-xs text-zinc-500 text-center">{props.caption}</p>}
    </div>
  );
}
